import {Inject, Injectable} from '@angular/core';
import {LOCAL_STORAGE, LOCATION} from '@ng-web-apis/common';
import {ActivatedRoute} from '@angular/router';
import {UmpireClientConfigService} from '@tisa-group/models';

export function authInitializerFactory(
  authInitializerService: AuthInitializerService,
  clientConfigService: UmpireClientConfigService,
): () => Promise<boolean[]> {
  return () => Promise.all([authInitializerService.init(), clientConfigService.init()]);
}

@Injectable({
  providedIn: 'root',
})
export class AuthInitializerService {
  constructor(
    @Inject(LOCAL_STORAGE) readonly localStorage: Storage,
    @Inject(LOCATION) readonly location: Location,
    readonly activatedRoute: ActivatedRoute,
  ) {}

  init(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      const localStorageToken = this.localStorage.getItem('TISA_TOKEN');
      const paramsToken = this.activatedRoute.snapshot.params.token;

      resolve(!!localStorageToken || !!paramsToken);
    });
  }
}
